import { CONDITION_GROUPS as CONDITION_GROUPS_CORE } from '@core/js/components/system/TagManager/constants';
import { CONDITION_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';

export * from '@core/js/components/system/TagManager/constants';

export const CONDITION_GROUPS = {
    ...CONDITION_GROUPS_CORE,
    additional: [
        ...CONDITION_GROUPS_CORE.additional,
        CONDITION_TYPE_BUZZ.excludePage
    ]
};
